import React from 'react';
import { Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import { SvgInformationCircle } from 'UI/res';

import { getFormattedDate, getFormattedTime } from '../utils';

import { FooterActionText } from './CallTimeSummaryFooter.styled';

const COPIES = strings.phoneDashboard.sections.callSummaryTable;

export const CallTimeSummaryFooter = ({ callLastUpdate }) => {
  return callLastUpdate ? (
    <>
      <Divider role="separator" />
      <Box px={2} pb={4}>
        <Grid container spacing={2}>
          <Grid item>
            <FPIcon
              role="img"
              aria-label="Info"
              component={SvgInformationCircle}
              onSetColor={palette => palette.info.main}
              size={24}
            />
          </Grid>

          <Grid item>
            <Box pl={2}>
              <Typography color="textSecondary" variant="body1">
                {strings.formatString(COPIES.footer.callLastUpdate, {
                  date: getFormattedDate(callLastUpdate)
                })}
                <strong>{getFormattedTime(callLastUpdate)}</strong>
              </Typography>

              <Box pl={1}>
                <FooterActionText content={COPIES.footer.summaryTime} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  ) : null;
};
